import { useCallback, useState } from 'react';
import { useEffectOnce } from 'react-use';

const isHashActive = (id: string): boolean => decodeURIComponent(window.location.hash.slice(1)) === id;

type OpenedByHashHookResult = [boolean, () => void];

export const useOpenedByHash = (id: string): OpenedByHashHookResult => {
  const [isOpen, setIsOpen] = useState(false);

  useEffectOnce(() => {
    if (isHashActive(id)) {
      setIsOpen(true);
    }
  });

  const handleToggle = useCallback(() => {
    setIsOpen((wasOpen) => {
      if (!wasOpen) {
        window.history.pushState('', '', `#${id}`);
      }

      return !wasOpen;
    });
  }, [id, setIsOpen]);

  return [isOpen, handleToggle];
};
